import React from 'react';
import PropTypes from 'prop-types';

import FullPageQuizQuestion, {
  FULL_PAGE_QUIZ_QUESTION_VARIANTS
} from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import OptionGroup from 'dpl/quiz/option_group/components/OptionGroup';
import OptionGroupOption from 'dpl/quiz/option_group/components/OptionGroupOption';
import { OPTION_GROUP_VARIANTS } from 'dpl/quiz/option_group/utils/constants';

const INPUT_NAME = 'gender_preference';

const options = [
  {
    icon: 'gender-female',
    title: 'Female',
    value: 'female'
  },
  {
    icon: 'gender-male',
    title: 'Male',
    value: 'male'
  },
  {
    icon: 'gender-any',
    title: 'Any gender',
    value: 'any'
  }
];

export default function QuizGenderPreferenceQuestion({
  formState,
  handleNextClick,
  onChange,
  isValid
}) {
  const value = formState[INPUT_NAME] || '';

  return (
    <FullPageQuizQuestion
      handleNextClick={handleNextClick}
      isValid={isValid}
      title="Choose your gender preference"
      variant={FULL_PAGE_QUIZ_QUESTION_VARIANTS.WIDE}
    >
      <OptionGroup variant={OPTION_GROUP_VARIANTS.ICON}>
        {options.map(o => (
          <OptionGroupOption
            type="radio"
            key={o.value}
            inputName={INPUT_NAME}
            icon={o.icon}
            title={o.title}
            value={o.value}
            onSelect={onChange(handleNextClick)}
            isSelected={o.value === value}
          />
        ))}
      </OptionGroup>
    </FullPageQuizQuestion>
  );
}

QuizGenderPreferenceQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired
};
